import { is } from 'ramda'
import { useDeeplinksService } from '@/composables/deeplinks'

/*
 * trigger from JS console:
 * document.dispatchEvent(new CustomEvent('BooksyWebViewMessage', { detail: { name: "deeplink", data: { "mobile_deeplink": "settings" } }}))
 */

const name = 'deeplink'

const callback = (data) => {
  if (is(String, data.mobile_deeplink)) {
    const { handle } = useDeeplinksService()
    handle(data.mobile_deeplink)
  }
}

export default { name, callback }
